import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Grid, Box } from "@material-ui/core";

import WizardLayout from "../../components/WizardLayout";
import WizardNavigation from "../../components/WizardNavigation";

import useWizardSteps from "../../hooks/useWizardSteps";
import TermsBox from "../../components/TermsBox";

import { fetchUserData } from "../../redux/user";

const suggestion = (
  <span>
    <b>¿Sabías</b> que tus beneficiarios son tus herederos legales?
  </span>
);

export default function Beneficiaries() {
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeStep] = useWizardSteps(2);

  const nextAction = () => {
    if (acceptTerms) {
      dispatch(fetchUserData());
      history.push("resumen");
    } else {
      setShowMessage(true);
    }
    return;
  };
  return (
    <WizardLayout activeStep={activeStep} suggestion={suggestion}>
      <Grid container item xs={12} justify="center">
        <Grid item container xs={11} sm={12}>
          <TermsBox
            title="Términos y Condiciones"
            setAcceptTerms={setAcceptTerms}
            acceptTerms={acceptTerms}
          >
            <Box
              fontSize={{ xs: 14, sm: 18 }}
              textAlign="justify"
              lineHeight="30px"
            >
              Fui informado de la facultad que poseo de designar beneficiarios,
              comunicándome al Centro de Atención a Clientes al 0800-666-5005 de Lunes a Viernes, de 9 hs
              a 18 hs. En caso de no declarar beneficiarios se considerarán por
              tales a los herederos.
            </Box>
          </TermsBox>
        </Grid>
        <Grid item container xs={12}>
          <WizardNavigation nextAction={nextAction} />
          {!acceptTerms && showMessage && (
            <Box mt="16px" ml="auto" color="red">
              Debe ACEPTAR los Términos y Condiciones para avanzar.
            </Box>
          )}
        </Grid>
      </Grid>
    </WizardLayout>
  );
}
